export class User {
  public id: number;
  public login?: string;
}
